import React, {Component} from 'react';
import PropTypes from 'prop-types';

import FullScreenManager from './FullScreenManager';

export const withFullScreenPropTypes = {
    isFullScreen: PropTypes.bool
};

const WithFullScreen = WrappedComponent => {
    class WithFullScreenClass extends Component {
        static propTypes = {
            ...WrappedComponent.propTypes,
            ...withFullScreenPropTypes
        };

        state = {
            isFullScreen: FullScreenManager.getIsFullScreen()
        };

        componentDidMount() {
            this.key = FullScreenManager.subscribe(this.onFullScreenUpdate);
        }

        componentWillUnmount() {
            FullScreenManager.unsubscribe(this.key);
        }

        shouldComponentUpdate(newProps, newState) {
            const {isFullScreen} = this.state;

            return isFullScreen !== newState.isFullScreen;
        }

        onFullScreenUpdate = isFullScreen => {
            this.setState({
                isFullScreen
            });
        };

        render() {
            const {forwardedRef} = this.props;
            const {isFullScreen} = this.state;

            return (
                <WrappedComponent
                    isFullScreen={isFullScreen}
                    exitFullScreen={FullScreenManager.exitFullScreen}
                    requestFullScreen={FullScreenManager.requestFullScreen}
                    ref={forwardedRef}
                    {...this.props}
                />
            );
        }
    }

    WithFullScreen.displayName = `WithFullScreen(${getDisplayName(WrappedComponent)})`;

    return React.forwardRef((props, ref) => {
        return <WithFullScreenClass {...props} forwardedRef={ref} />;
    });
};

function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default WithFullScreen;
